var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1 px-2 rounded border",style:({ backgroundColor: _vm.color })},[_c('span',[_vm._v(_vm._s(_vm.params.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }